import { Quality, Value, listValues } from '@kudos/http-client'
import { Selectable } from '@shared/filters/selections'
import { useTranslatedField } from '@shared/utils/useTranslatedField'
import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'

const useQualities = () => {
  const [qualities, setQualities] = useState<Selectable[]>()
  const getTranslatedField = useTranslatedField()
  const { data: values, isFetched } = useQuery({
    queryKey: ['listValuesAndQualities'],
    queryFn: () =>
      listValues({
        embeds: ['qualities'],
      }),
  })

  const mapQualitySelectable = (value: Value, quality: Quality) => {
    const selectable: Selectable = {
      id: quality.id,
      name: getTranslatedField(quality, 'name'),
      color: value.color,
      tooltipValue: getTranslatedField(value, 'name'),
    }
    return selectable
  }

  useEffect(() => {
    if (!!values) {
      setQualities(
        values.flatMap(
          value => value.qualities?.map(quality => mapQualitySelectable(value, quality)) ?? [],
        ),
      )
    }
  }, [isFetched, values])

  return { qualities, isFetched }
}

export default useQualities
